import { useState, useEffect, useRef } from 'react'
import { Season, SeasonPayload } from '../../types/catalog'
import { FormField, Input, Row, Select } from '../../components/ui/FormField'
import { TranslationFields } from '../../components/ui/TranslationFields'

const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

interface Props {
  initial?: Season | null
  onChange: (payload: SeasonPayload) => void
}

export function SeasonForm({ initial, onChange }: Props) {
  const [code, setCode] = useState(initial?.code ?? '')
  const [startMonth, setStartMonth] = useState(initial?.startMonth ?? 1)
  const [endMonth, setEndMonth] = useState(initial?.endMonth ?? 3)
  const [position, setPosition] = useState(initial?.position ?? 0)
  const [translations, setTranslations] = useState(
    initial?.translations ?? [
      { locale: 'en', name: '' },
      { locale: 'es', name: '' },
    ]
  )

  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    onChangeRef.current({ code, startMonth, endMonth, position, translations })
  }, [code, startMonth, endMonth, position, translations])

  return (
    <>
      <Row>
        <FormField label="Code" hint="e.g. SPRING">
          <Input
            placeholder="SPRING"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
          />
        </FormField>
        <FormField label="Position">
          <Input
            type="number"
            value={position}
            onChange={e => setPosition(Number(e.target.value))}
          />
        </FormField>
      </Row>

      <Row>
        <FormField label="Start month">
          <Select value={startMonth} onChange={e => setStartMonth(Number(e.target.value))}>
            {MONTHS.map(m => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </Select>
        </FormField>
        <FormField label="End month">
          <Select value={endMonth} onChange={e => setEndMonth(Number(e.target.value))}>
            {MONTHS.map(m => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </Select>
        </FormField>
      </Row>

      <TranslationFields translations={translations} onChange={setTranslations} />
    </>
  )
}
